﻿/* tslint:disable */
/* eslint-disable */
/**
 * chinaone
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 * @interface ResponseVoid
 */
export interface ResponseVoid {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseVoid
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseVoid
     */
    message?: string;
    /**
     * 
     * @type {Null}
     * @memberof ResponseVoid
     */
    data?: null;
}

/**
 * Check if a given object implements the ResponseVoid interface.
 */
export function instanceOfResponseVoid(value: object): value is ResponseVoid {
    return true;
}

export function ResponseVoidFromJSON(json: any): ResponseVoid {
    return ResponseVoidFromJSONTyped(json, false);
}

export function ResponseVoidFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseVoid {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message']
    };
}

export function ResponseVoidToJSON(json: any): ResponseVoid {
    return ResponseVoidToJSONTyped(json, false);
}

export function ResponseVoidToJSONTyped(value?: ResponseVoid | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message']
    };
}

